import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {DevSupport} from "@react-buddy/ide-toolbox";
import {ComponentPreviews, useInitial} from "./dev";

// Suppress ResizeObserver loop errors from GSAP ScrollSmoother
// This is a benign error that doesn't affect functionality
// Patch at multiple levels to catch all instances

// 1. Patch window.error handler
const resizeObserverErrorHandler = (event: ErrorEvent) => {
  if (
    event.message === 'ResizeObserver loop completed with undelivered notifications.' ||
    event.message === 'ResizeObserver loop limit exceeded'
  ) {
    event.stopImmediatePropagation();
    event.preventDefault();
    return true;
  }
  return false;
};
window.addEventListener('error', resizeObserverErrorHandler);

// 2. Patch console.error to filter out ResizeObserver errors
const originalConsoleError = console.error;
console.error = (...args: any[]) => {
  const errorMessage = args[0]?.toString() || '';
  if (
    errorMessage.includes('ResizeObserver loop completed with undelivered notifications') ||
    errorMessage.includes('ResizeObserver loop limit exceeded')
  ) {
    return;
  }
  originalConsoleError.apply(console, args);
};

// 3. Wrap ResizeObserver to debounce callbacks and prevent loop errors
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class extends OriginalResizeObserver {
  constructor(callback: ResizeObserverCallback) {
    super((entries, observer) => {
      // Use requestAnimationFrame to defer the callback
      requestAnimationFrame(() => {
        try {
          callback(entries, observer);
        } catch (e) {
          // Silently catch ResizeObserver errors
          const error = e as Error;
          if (
            !error.message.includes('ResizeObserver loop') &&
            !error.message.includes('ResizeObserver loop limit exceeded')
          ) {
            throw e;
          }
        }
      });
    });
  }
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<DevSupport ComponentPreviews={ComponentPreviews}
                        useInitialHook={useInitial}
>
    <App/>
</DevSupport>);
